// ============================================================================
// Desktop Shell (Pake) Detection
// ============================================================================
// The desktop app is a Pake (Tauri) wrapper around the deployed site (see
// README "Desktop app (Pake)"). Pake injects window.pakeConfig into every
// webview before page scripts run, and the underlying Tauri runtime injects
// the __TAURI_* globals - a normal browser has none of these, so detection
// needs nothing passed via --inject.
//
// REQUIRED_SHELL_CHECKS is the contract between the deployed web app and the
// installed shell binary: each entry is a capability the current web app
// expects the shell to have been built with. The web app ships continuously,
// but the shell only changes when someone installs a new MSI - so when a
// change needs a shell rebuild, add a check here and outdated installs get
// the reinstall notice on boot (app.js) while everything else keeps working.

const REQUIRED_SHELL_CHECKS = [
    {
        // pake-cli --new-window: lets window.open(<internal url>, '_blank')
        // open a real second app window (sidebar pop-outs). Without it Pake
        // rewrites the call to same-window navigation. Builds too old to
        // inject pakeConfig at all fail this too - they equally need the
        // reinstall. Both key spellings checked in case serde casing shifts
        // between pake versions.
        id: 'new-window',
        ok: () => {
            const cfg = window.pakeConfig;
            return !!cfg && (cfg.new_window === true || cfg.newWindow === true);
        }
    }
];

/** True when running inside the Pake desktop shell (any build age). */
export function isDesktopShell() {
    return 'pakeConfig' in window
        || '__TAURI_INTERNALS__' in window
        || '__TAURI__' in window;
}

/**
 * True when running inside the desktop shell but the installed shell binary
 * is missing a capability the web app relies on - i.e. this machine needs a
 * one-off reinstall from the latest MSI. Always false in a normal browser.
 */
export function shellUpdateRequired() {
    if (!isDesktopShell()) return false;
    return REQUIRED_SHELL_CHECKS.some((check) => {
        try {
            return !check.ok();
        } catch {
            return true;
        }
    });
}
